export const COUNTRIES = [
  {
    commonName: 'Aruba',
    officialName: 'Aruba',
  },
  {
    commonName: 'Afghanistan',
    officialName: 'Islamic Republic of Afghanistan',
  },
  {
    commonName: 'Angola',
    officialName: 'Republic of Angola',
  },
  {
    commonName: 'Anguilla',
    officialName: 'Anguilla',
  },
  {
    commonName: 'Åland Islands',
    officialName: 'Åland Islands',
  },
  {
    commonName: 'Albania',
    officialName: 'Republic of Albania',
  },
  {
    commonName: 'Andorra',
    officialName: 'Principality of Andorra',
  },
  {
    commonName: 'United Arab Emirates',
    officialName: 'United Arab Emirates',
  },
  {
    commonName: 'Argentina',
    officialName: 'Argentine Republic',
  },
  {
    commonName: 'Armenia',
    officialName: 'Republic of Armenia',
  },
  {
    commonName: 'American Samoa',
    officialName: 'American Samoa',
  },
  {
    commonName: 'Antarctica',
    officialName: 'Antarctica',
  },
  {
    commonName: 'French Southern and Antarctic Lands',
    officialName: 'Territory of the French Southern and Antarctic Lands',
  },
  {
    commonName: 'Antigua and Barbuda',
    officialName: 'Antigua and Barbuda',
  },
  {
    commonName: 'Australia',
    officialName: 'Commonwealth of Australia',
  },
  {
    commonName: 'Austria',
    officialName: 'Republic of Austria',
  },
  {
    commonName: 'Azerbaijan',
    officialName: 'Republic of Azerbaijan',
  },
  {
    commonName: 'Burundi',
    officialName: 'Republic of Burundi',
  },
  {
    commonName: 'Belgium',
    officialName: 'Kingdom of Belgium',
  },
  {
    commonName: 'Benin',
    officialName: 'Republic of Benin',
  },
  {
    commonName: 'Burkina Faso',
    officialName: 'Burkina Faso',
  },
  {
    commonName: 'Bangladesh',
    officialName: "People's Republic of Bangladesh",
  },
  {
    commonName: 'Bulgaria',
    officialName: 'Republic of Bulgaria',
  },
  {
    commonName: 'Bahrain',
    officialName: 'Kingdom of Bahrain',
  },
  {
    commonName: 'Bahamas',
    officialName: 'Commonwealth of the Bahamas',
  },
  {
    commonName: 'Bosnia and Herzegovina',
    officialName: 'Bosnia and Herzegovina',
  },
  {
    commonName: 'Saint Barthélemy',
    officialName: 'Collectivity of Saint Barthélemy',
  },
  {
    commonName: 'Saint Helena, Ascension and Tristan da Cunha',
    officialName: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    commonName: 'Belarus',
    officialName: 'Republic of Belarus',
  },
  {
    commonName: 'Belize',
    officialName: 'Belize',
  },
  {
    commonName: 'Bermuda',
    officialName: 'Bermuda',
  },
  {
    commonName: 'Bolivia',
    officialName: 'Plurinational State of Bolivia',
  },
  {
    commonName: 'Caribbean Netherlands',
    officialName: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    commonName: 'Brazil',
    officialName: 'Federative Republic of Brazil',
  },
  {
    commonName: 'Barbados',
    officialName: 'Barbados',
  },
  {
    commonName: 'Brunei',
    officialName: 'Nation of Brunei, Abode of Peace',
  },
  {
    commonName: 'Bhutan',
    officialName: 'Kingdom of Bhutan',
  },
  {
    commonName: 'Bouvet Island',
    officialName: 'Bouvet Island',
  },
  {
    commonName: 'Botswana',
    officialName: 'Republic of Botswana',
  },
  {
    commonName: 'Central African Republic',
    officialName: 'Central African Republic',
  },
  {
    commonName: 'Canada',
    officialName: 'Canada',
  },
  {
    commonName: 'Cocos (Keeling) Islands',
    officialName: 'Territory of the Cocos (Keeling) Islands',
  },
  {
    commonName: 'Switzerland',
    officialName: 'Swiss Confederation',
  },
  {
    commonName: 'Chile',
    officialName: 'Republic of Chile',
  },
  {
    commonName: 'China',
    officialName: "People's Republic of China",
  },
  {
    commonName: 'Ivory Coast',
    officialName: "Republic of Côte d'Ivoire",
  },
  {
    commonName: 'Cameroon',
    officialName: 'Republic of Cameroon',
  },
  {
    commonName: 'DR Congo',
    officialName: 'Democratic Republic of the Congo',
  },
  {
    commonName: 'Congo',
    officialName: 'Republic of the Congo',
  },
  {
    commonName: 'Cook Islands',
    officialName: 'Cook Islands',
  },
  {
    commonName: 'Colombia',
    officialName: 'Republic of Colombia',
  },
  {
    commonName: 'Comoros',
    officialName: 'Union of the Comoros',
  },
  {
    commonName: 'Cape Verde',
    officialName: 'Republic of Cabo Verde',
  },
  {
    commonName: 'Costa Rica',
    officialName: 'Republic of Costa Rica',
  },
  {
    commonName: 'Cuba',
    officialName: 'Republic of Cuba',
  },
  {
    commonName: 'Curaçao',
    officialName: 'Country of Curaçao',
  },
  {
    commonName: 'Christmas Island',
    officialName: 'Territory of Christmas Island',
  },
  {
    commonName: 'Cayman Islands',
    officialName: 'Cayman Islands',
  },
  {
    commonName: 'Cyprus',
    officialName: 'Republic of Cyprus',
  },
  {
    commonName: 'Czechia',
    officialName: 'Czech Republic',
  },
  {
    commonName: 'Germany',
    officialName: 'Federal Republic of Germany',
  },
  {
    commonName: 'Djibouti',
    officialName: 'Republic of Djibouti',
  },
  {
    commonName: 'Dominica',
    officialName: 'Commonwealth of Dominica',
  },
  {
    commonName: 'Denmark',
    officialName: 'Kingdom of Denmark',
  },
  {
    commonName: 'Dominican Republic',
    officialName: 'Dominican Republic',
  },
  {
    commonName: 'Algeria',
    officialName: "People's Democratic Republic of Algeria",
  },
  {
    commonName: 'Ecuador',
    officialName: 'Republic of Ecuador',
  },
  {
    commonName: 'Egypt',
    officialName: 'Arab Republic of Egypt',
  },
  {
    commonName: 'Eritrea',
    officialName: 'State of Eritrea',
  },
  {
    commonName: 'Western Sahara',
    officialName: 'Sahrawi Arab Democratic Republic',
  },
  {
    commonName: 'Spain',
    officialName: 'Kingdom of Spain',
  },
  {
    commonName: 'Estonia',
    officialName: 'Republic of Estonia',
  },
  {
    commonName: 'Ethiopia',
    officialName: 'Federal Democratic Republic of Ethiopia',
  },
  {
    commonName: 'Finland',
    officialName: 'Republic of Finland',
  },
  {
    commonName: 'Fiji',
    officialName: 'Republic of Fiji',
  },
  {
    commonName: 'Falkland Islands',
    officialName: 'Falkland Islands',
  },
  {
    commonName: 'France',
    officialName: 'French Republic',
  },
  {
    commonName: 'Faroe Islands',
    officialName: 'Faroe Islands',
  },
  {
    commonName: 'Micronesia',
    officialName: 'Federated States of Micronesia',
  },
  {
    commonName: 'Gabon',
    officialName: 'Gabonese Republic',
  },
  {
    commonName: 'United Kingdom',
    officialName: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    commonName: 'Georgia',
    officialName: 'Georgia',
  },
  {
    commonName: 'Guernsey',
    officialName: 'Bailiwick of Guernsey',
  },
  {
    commonName: 'Ghana',
    officialName: 'Republic of Ghana',
  },
  {
    commonName: 'Gibraltar',
    officialName: 'Gibraltar',
  },
  {
    commonName: 'Guinea',
    officialName: 'Republic of Guinea',
  },
  {
    commonName: 'Guadeloupe',
    officialName: 'Guadeloupe',
  },
  {
    commonName: 'Gambia',
    officialName: 'Republic of the Gambia',
  },
  {
    commonName: 'Guinea-Bissau',
    officialName: 'Republic of Guinea-Bissau',
  },
  {
    commonName: 'Equatorial Guinea',
    officialName: 'Republic of Equatorial Guinea',
  },
  {
    commonName: 'Greece',
    officialName: 'Hellenic Republic',
  },
  {
    commonName: 'Grenada',
    officialName: 'Grenada',
  },
  {
    commonName: 'Greenland',
    officialName: 'Greenland',
  },
  {
    commonName: 'Guatemala',
    officialName: 'Republic of Guatemala',
  },
  {
    commonName: 'French Guiana',
    officialName: 'Guiana',
  },
  {
    commonName: 'Guam',
    officialName: 'Guam',
  },
  {
    commonName: 'Guyana',
    officialName: 'Co-operative Republic of Guyana',
  },
  {
    commonName: 'Hong Kong',
    officialName: "Hong Kong Special Administrative Region of the People's Republic of China",
  },
  {
    commonName: 'Heard Island and McDonald Islands',
    officialName: 'Heard Island and McDonald Islands',
  },
  {
    commonName: 'Honduras',
    officialName: 'Republic of Honduras',
  },
  {
    commonName: 'Croatia',
    officialName: 'Republic of Croatia',
  },
  {
    commonName: 'Haiti',
    officialName: 'Republic of Haiti',
  },
  {
    commonName: 'Hungary',
    officialName: 'Hungary',
  },
  {
    commonName: 'Indonesia',
    officialName: 'Republic of Indonesia',
  },
  {
    commonName: 'Isle of Man',
    officialName: 'Isle of Man',
  },
  {
    commonName: 'India',
    officialName: 'Republic of India',
  },
  {
    commonName: 'British Indian Ocean Territory',
    officialName: 'British Indian Ocean Territory',
  },
  {
    commonName: 'Ireland',
    officialName: 'Republic of Ireland',
  },
  {
    commonName: 'Iran',
    officialName: 'Islamic Republic of Iran',
  },
  {
    commonName: 'Iraq',
    officialName: 'Republic of Iraq',
  },
  {
    commonName: 'Iceland',
    officialName: 'Iceland',
  },
  {
    commonName: 'Israel',
    officialName: 'State of Israel',
  },
  {
    commonName: 'Italy',
    officialName: 'Italian Republic',
  },
  {
    commonName: 'Jamaica',
    officialName: 'Jamaica',
  },
  {
    commonName: 'Jersey',
    officialName: 'Bailiwick of Jersey',
  },
  {
    commonName: 'Jordan',
    officialName: 'Hashemite Kingdom of Jordan',
  },
  {
    commonName: 'Japan',
    officialName: 'Japan',
  },
  {
    commonName: 'Kazakhstan',
    officialName: 'Republic of Kazakhstan',
  },
  {
    commonName: 'Kenya',
    officialName: 'Republic of Kenya',
  },
  {
    commonName: 'Kyrgyzstan',
    officialName: 'Kyrgyz Republic',
  },
  {
    commonName: 'Cambodia',
    officialName: 'Kingdom of Cambodia',
  },
  {
    commonName: 'Kiribati',
    officialName: 'Independent and Sovereign Republic of Kiribati',
  },
  {
    commonName: 'Saint Kitts and Nevis',
    officialName: 'Federation of Saint Christopher and Nevis',
  },
  {
    commonName: 'South Korea',
    officialName: 'Republic of Korea',
  },
  {
    commonName: 'Kosovo',
    officialName: 'Republic of Kosovo',
  },
  {
    commonName: 'Kuwait',
    officialName: 'State of Kuwait',
  },
  {
    commonName: 'Laos',
    officialName: "Lao People's Democratic Republic",
  },
  {
    commonName: 'Lebanon',
    officialName: 'Lebanese Republic',
  },
  {
    commonName: 'Liberia',
    officialName: 'Republic of Liberia',
  },
  {
    commonName: 'Libya',
    officialName: 'State of Libya',
  },
  {
    commonName: 'Saint Lucia',
    officialName: 'Saint Lucia',
  },
  {
    commonName: 'Liechtenstein',
    officialName: 'Principality of Liechtenstein',
  },
  {
    commonName: 'Sri Lanka',
    officialName: 'Democratic Socialist Republic of Sri Lanka',
  },
  {
    commonName: 'Lesotho',
    officialName: 'Kingdom of Lesotho',
  },
  {
    commonName: 'Lithuania',
    officialName: 'Republic of Lithuania',
  },
  {
    commonName: 'Luxembourg',
    officialName: 'Grand Duchy of Luxembourg',
  },
  {
    commonName: 'Latvia',
    officialName: 'Republic of Latvia',
  },
  {
    commonName: 'Macau',
    officialName: "Macao Special Administrative Region of the People's Republic of China",
  },
  {
    commonName: 'Saint Martin',
    officialName: 'Saint Martin',
  },
  {
    commonName: 'Morocco',
    officialName: 'Kingdom of Morocco',
  },
  {
    commonName: 'Monaco',
    officialName: 'Principality of Monaco',
  },
  {
    commonName: 'Moldova',
    officialName: 'Republic of Moldova',
  },
  {
    commonName: 'Madagascar',
    officialName: 'Republic of Madagascar',
  },
  {
    commonName: 'Maldives',
    officialName: 'Republic of the Maldives',
  },
  {
    commonName: 'Mexico',
    officialName: 'United Mexican States',
  },
  {
    commonName: 'Marshall Islands',
    officialName: 'Republic of the Marshall Islands',
  },
  {
    commonName: 'North Macedonia',
    officialName: 'Republic of North Macedonia',
  },
  {
    commonName: 'Mali',
    officialName: 'Republic of Mali',
  },
  {
    commonName: 'Malta',
    officialName: 'Republic of Malta',
  },
  {
    commonName: 'Myanmar',
    officialName: 'Republic of the Union of Myanmar',
  },
  {
    commonName: 'Montenegro',
    officialName: 'Montenegro',
  },
  {
    commonName: 'Mongolia',
    officialName: 'Mongolia',
  },
  {
    commonName: 'Northern Mariana Islands',
    officialName: 'Commonwealth of the Northern Mariana Islands',
  },
  {
    commonName: 'Mozambique',
    officialName: 'Republic of Mozambique',
  },
  {
    commonName: 'Mauritania',
    officialName: 'Islamic Republic of Mauritania',
  },
  {
    commonName: 'Montserrat',
    officialName: 'Montserrat',
  },
  {
    commonName: 'Martinique',
    officialName: 'Martinique',
  },
  {
    commonName: 'Mauritius',
    officialName: 'Republic of Mauritius',
  },
  {
    commonName: 'Malawi',
    officialName: 'Republic of Malawi',
  },
  {
    commonName: 'Malaysia',
    officialName: 'Malaysia',
  },
  {
    commonName: 'Mayotte',
    officialName: 'Department of Mayotte',
  },
  {
    commonName: 'Namibia',
    officialName: 'Republic of Namibia',
  },
  {
    commonName: 'New Caledonia',
    officialName: 'New Caledonia',
  },
  {
    commonName: 'Niger',
    officialName: 'Republic of Niger',
  },
  {
    commonName: 'Norfolk Island',
    officialName: 'Territory of Norfolk Island',
  },
  {
    commonName: 'Nigeria',
    officialName: 'Federal Republic of Nigeria',
  },
  {
    commonName: 'Nicaragua',
    officialName: 'Republic of Nicaragua',
  },
  {
    commonName: 'Niue',
    officialName: 'Niue',
  },
  {
    commonName: 'Netherlands',
    officialName: 'Kingdom of the Netherlands',
  },
  {
    commonName: 'Norway',
    officialName: 'Kingdom of Norway',
  },
  {
    commonName: 'Nepal',
    officialName: 'Federal Democratic Republic of Nepal',
  },
  {
    commonName: 'Nauru',
    officialName: 'Republic of Nauru',
  },
  {
    commonName: 'New Zealand',
    officialName: 'New Zealand',
  },
  {
    commonName: 'Oman',
    officialName: 'Sultanate of Oman',
  },
  {
    commonName: 'Pakistan',
    officialName: 'Islamic Republic of Pakistan',
  },
  {
    commonName: 'Panama',
    officialName: 'Republic of Panama',
  },
  {
    commonName: 'Pitcairn Islands',
    officialName: 'Pitcairn Group of Islands',
  },
  {
    commonName: 'Peru',
    officialName: 'Republic of Peru',
  },
  {
    commonName: 'Philippines',
    officialName: 'Republic of the Philippines',
  },
  {
    commonName: 'Palau',
    officialName: 'Republic of Palau',
  },
  {
    commonName: 'Papua New Guinea',
    officialName: 'Independent State of Papua New Guinea',
  },
  {
    commonName: 'Poland',
    officialName: 'Republic of Poland',
  },
  {
    commonName: 'Puerto Rico',
    officialName: 'Commonwealth of Puerto Rico',
  },
  {
    commonName: 'North Korea',
    officialName: "Democratic People's Republic of Korea",
  },
  {
    commonName: 'Portugal',
    officialName: 'Portuguese Republic',
  },
  {
    commonName: 'Paraguay',
    officialName: 'Republic of Paraguay',
  },
  {
    commonName: 'Palestine',
    officialName: 'State of Palestine',
  },
  {
    commonName: 'French Polynesia',
    officialName: 'French Polynesia',
  },
  {
    commonName: 'Qatar',
    officialName: 'State of Qatar',
  },
  {
    commonName: 'Réunion',
    officialName: 'Réunion Island',
  },
  {
    commonName: 'Romania',
    officialName: 'Romania',
  },
  {
    commonName: 'Russia',
    officialName: 'Russian Federation',
  },
  {
    commonName: 'Rwanda',
    officialName: 'Republic of Rwanda',
  },
  {
    commonName: 'Saudi Arabia',
    officialName: 'Kingdom of Saudi Arabia',
  },
  {
    commonName: 'Sudan',
    officialName: 'Republic of the Sudan',
  },
  {
    commonName: 'Senegal',
    officialName: 'Republic of Senegal',
  },
  {
    commonName: 'Singapore',
    officialName: 'Republic of Singapore',
  },
  {
    commonName: 'South Georgia',
    officialName: 'South Georgia and the South Sandwich Islands',
  },
  {
    commonName: 'Svalbard and Jan Mayen',
    officialName: 'Svalbard og Jan Mayen',
  },
  {
    commonName: 'Solomon Islands',
    officialName: 'Solomon Islands',
  },
  {
    commonName: 'Sierra Leone',
    officialName: 'Republic of Sierra Leone',
  },
  {
    commonName: 'El Salvador',
    officialName: 'Republic of El Salvador',
  },
  {
    commonName: 'San Marino',
    officialName: 'Most Serene Republic of San Marino',
  },
  {
    commonName: 'Somalia',
    officialName: 'Federal Republic of Somalia',
  },
  {
    commonName: 'Saint Pierre and Miquelon',
    officialName: 'Saint Pierre and Miquelon',
  },
  {
    commonName: 'Serbia',
    officialName: 'Republic of Serbia',
  },
  {
    commonName: 'South Sudan',
    officialName: 'Republic of South Sudan',
  },
  {
    commonName: 'São Tomé and Príncipe',
    officialName: 'Democratic Republic of São Tomé and Príncipe',
  },
  {
    commonName: 'Suriname',
    officialName: 'Republic of Suriname',
  },
  {
    commonName: 'Slovakia',
    officialName: 'Slovak Republic',
  },
  {
    commonName: 'Slovenia',
    officialName: 'Republic of Slovenia',
  },
  {
    commonName: 'Sweden',
    officialName: 'Kingdom of Sweden',
  },
  {
    commonName: 'Eswatini',
    officialName: 'Kingdom of Eswatini',
  },
  {
    commonName: 'Sint Maarten',
    officialName: 'Sint Maarten',
  },
  {
    commonName: 'Seychelles',
    officialName: 'Republic of Seychelles',
  },
  {
    commonName: 'Syria',
    officialName: 'Syrian Arab Republic',
  },
  {
    commonName: 'Turks and Caicos Islands',
    officialName: 'Turks and Caicos Islands',
  },
  {
    commonName: 'Chad',
    officialName: 'Republic of Chad',
  },
  {
    commonName: 'Togo',
    officialName: 'Togolese Republic',
  },
  {
    commonName: 'Thailand',
    officialName: 'Kingdom of Thailand',
  },
  {
    commonName: 'Tajikistan',
    officialName: 'Republic of Tajikistan',
  },
  {
    commonName: 'Tokelau',
    officialName: 'Tokelau',
  },
  {
    commonName: 'Turkmenistan',
    officialName: 'Turkmenistan',
  },
  {
    commonName: 'Timor-Leste',
    officialName: 'Democratic Republic of Timor-Leste',
  },
  {
    commonName: 'Tonga',
    officialName: 'Kingdom of Tonga',
  },
  {
    commonName: 'Trinidad and Tobago',
    officialName: 'Republic of Trinidad and Tobago',
  },
  {
    commonName: 'Tunisia',
    officialName: 'Tunisian Republic',
  },
  {
    commonName: 'Türkiye',
    officialName: 'Republic of Türkiye',
  },
  {
    commonName: 'Tuvalu',
    officialName: 'Tuvalu',
  },
  {
    commonName: 'Taiwan',
    officialName: 'Republic of China (Taiwan)',
  },
  {
    commonName: 'Tanzania',
    officialName: 'United Republic of Tanzania',
  },
  {
    commonName: 'Uganda',
    officialName: 'Republic of Uganda',
  },
  {
    commonName: 'Ukraine',
    officialName: 'Ukraine',
  },
  {
    commonName: 'United States Minor Outlying Islands',
    officialName: 'United States Minor Outlying Islands',
  },
  {
    commonName: 'Uruguay',
    officialName: 'Oriental Republic of Uruguay',
  },
  {
    commonName: 'United States',
    officialName: 'United States of America',
  },
  {
    commonName: 'Uzbekistan',
    officialName: 'Republic of Uzbekistan',
  },
  {
    commonName: 'Vatican City',
    officialName: 'Vatican City State',
  },
  {
    commonName: 'Saint Vincent and the Grenadines',
    officialName: 'Saint Vincent and the Grenadines',
  },
  {
    commonName: 'Venezuela',
    officialName: 'Bolivarian Republic of Venezuela',
  },
  {
    commonName: 'British Virgin Islands',
    officialName: 'Virgin Islands',
  },
  {
    commonName: 'United States Virgin Islands',
    officialName: 'Virgin Islands of the United States',
  },
  {
    commonName: 'Vietnam',
    officialName: 'Socialist Republic of Vietnam',
  },
  {
    commonName: 'Vanuatu',
    officialName: 'Republic of Vanuatu',
  },
  {
    commonName: 'Wallis and Futuna',
    officialName: 'Territory of the Wallis and Futuna Islands',
  },
  {
    commonName: 'Samoa',
    officialName: 'Independent State of Samoa',
  },
  {
    commonName: 'Yemen',
    officialName: 'Republic of Yemen',
  },
  {
    commonName: 'South Africa',
    officialName: 'Republic of South Africa',
  },
  {
    commonName: 'Zambia',
    officialName: 'Republic of Zambia',
  },
  {
    commonName: 'Zimbabwe',
    officialName: 'Republic of Zimbabwe',
  },
] as const;
